<div>
    <div class="col-12">
        <ui-page-header [title]="pageTitle || (hrKey.hrCommonCodeText.pageHeader | translate)" [pageCode]="pageCodeModelA.pageCode"></ui-page-header>
    </div>
    <code-text-list
        [pageCodeModel]="pageCodeModelA"
        [listTitle]="listTitle"
        (onSearchCleared)="onSearchCleared()"
        (onDiscriminatorValueChangedEvent)="onDiscriminatorValueChanged($event)"
        (onRowSelectEventEmitter)="onRowSelected($event)"
        (onRowUnSelectEventEmitter)="onRowUnSelected()"
    >
        <hr-toolbar
            toolbar
            [idPrefix]="pageCodeModelA.pageCode"
            [form]="this"
            [addButtonDisabled]="addButtonDisabled"
            [copyButtonDisabled]="copyButtonDisabled"
            [editButtonDisabled]="editButtonDisabled"
            [removeButtonDisabled]="removeButtonDisabled"
        ></hr-toolbar>
    </code-text-list>
    <ui-sidebar [display]="formVisibility">
        <code-text-form
            modelForm
            class="col-4 hr-padding-clear"
            [pageCodeModel]="pageCodeModelA"
            [selectedDiscriminator]="selectedDiscriminator"
            [selectedItem]="selectedItem"
            (setAllButtonDisabledEvent)="setButtonsDisabledState($event)"
            (onCloseEvent)="onFormClosed($event)"
        ></code-text-form>
    </ui-sidebar>

    <p-confirmDialog [autoZIndex]="true" [baseZIndex]="99999999999" appendTo="body"></p-confirmDialog>
</div>
